import { useState, useEffect } from 'react';
import { getConsumption } from '../../../service/consumos/Consumos';
import { SimpleAlert } from '../../../../_mexablock/helpers';
import { ApiResponse, DocData } from '../models/ConsumosModel';

export const useGetAll = (body: any) => {
  const [data, setData] = useState<DocData | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setIsLoading(true);

        const response = await getConsumption(body);

        if (response.data?.status === 'fail') {
          SimpleAlert(
            response.data.message || 'Error desconocido',
            3000,
            'error',
          );
          setData(null);
          return;
        }

        if (response.data?.status === 'success') {
          setData(response.data.doc.data);
        }
      } catch (error: any) {
        const backendMessage =
          error?.response?.data?.message ||
          'El valor capturado no existe, revisa que el número sea el correcto';

        SimpleAlert(backendMessage, 3000, 'error');
        setData(null);
      } finally {
        setIsLoading(false);
      }
    };

    if (body && Object.keys(body).length > 0) {
      fetchPost();
    }
  }, [body]);

  return { data, isLoading };
};
